import { apiClient } from "@/shared/api/apiClient";
import type { LoginResponse } from "@/shared/api/types";

export type AuthChannel = "EMAIL" | "SMS";

/** Hangi giriş kanallarının açık olduğunu bildiren public (token gerektirmeyen) uç. */
export interface AuthCapabilities {
  emailLoginEnabled: boolean;
  smsLoginEnabled: boolean;
}

export const DEFAULT_CAPABILITIES: AuthCapabilities = {
  emailLoginEnabled: true,
  smsLoginEnabled: false,
};

export const authApi = {
  getCapabilities: (): Promise<AuthCapabilities> =>
    apiClient.get<AuthCapabilities>("/auth/capabilities").then((r) => r.data),

  requestOtp: (channel: AuthChannel, value: string): Promise<void> =>
    apiClient.post("/auth/request-otp", { channel, value }).then(() => undefined),

  login: (channel: AuthChannel, value: string, code: string): Promise<LoginResponse> =>
    apiClient.post<LoginResponse>("/auth/login", { channel, value, code }).then((r) => r.data),

  /** Okul-seçim adımı: birden çok okul kaydı olan kullanıcı hangi okul adına gireceğini seçer. */
  selectSchool: (selectionToken: string, recordId: string): Promise<LoginResponse> =>
    apiClient
      .post<LoginResponse>("/auth/select-school", { selectionToken, recordId })
      .then((r) => r.data),

  /** Oturum-içi okul değiştirme: çoklu-okul yöneticisi çıkış yapmadan kardeş kaydına geçer. */
  switchSchool: (recordId: string): Promise<LoginResponse> =>
    apiClient.post<LoginResponse>("/auth/switch-school", { recordId }).then((r) => r.data),
};
